var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":_vm.type,"disabled":_vm.isSending}},[(_vm.isSending)?[(_vm.isSending)?_c('font-awesome-icon',{attrs:{"icon":"spinner","spin":""}}):_vm._e()]:[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('submit')))]})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }